<template>
  <div class="card card-body rounded-top">
    <component-table
      actionsWidth="215px"
      entityType="club"
      :columns="table.columns"
      :data="list"
      :actions="table.actions"
      :total="count"
      @add="goToAddClubPage"
      @edit="goToEditPage($event.id)"
      @delete="showDeleteDialog($event.id)"
      @view="goToProfile($event.id)"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ComponentTable from '@/components/table/Table';
import { VIEW_ACTION, DEFAULT_TABLE_ACTIONS } from '@/utils/constants';
import { address } from '@/filters/address';
import { listMixin } from '@/mixins/list';

const messages = {
  listError: 'messages.club.listError',
  getError: 'messages.club.getError',
  added: 'messages.club.added',
  addError: 'messages.club.addError',
  updated: 'messages.club.updated',
  updateError: 'messages.club.updateError',
  deleted: 'messages.club.deleted',
  deleteConfirm: 'messages.club.deleteConfirm',
  deleteError: 'messages.club.deleteError'
};

// @vuese
// Lista klubów
// @group Clubs
export default {
  mixins: [listMixin('club', messages)],
  data: () => ({
    table: {
      columns: [
        { name: 'name', displayName: 'columns.name', sortable: true, action: VIEW_ACTION.event },
        { name: 'address', displayName: 'columns.address', width: '25' }
      ],
      actions: [VIEW_ACTION, ...DEFAULT_TABLE_ACTIONS]
    }
  }),
  computed: {
    ...mapState({
      list: state => {
        return state.club.list.map(item => {
          item.address = address(item);
          return item;
        });
      }
    })
  },
  methods: {
    // Przenosi do profilu klubu
    goToProfile(clubId) {
      this.$router.push({ name: 'club', params: { clubId } });
    },
    // Przenosi do formularza dodawania klubu
    goToAddClubPage() {
      this.$router.push({ name: 'clubAdd' });
    },
    // Przeniesienie na stronę edycji klubu
    goToEditPage(clubId) {
      this.$router.push({ name: 'clubEdit', params: { clubId } });
    }
  },
  components: {
    ComponentTable
  }
};
</script>
